import * as PIXI from "pixi.js";

export default function Text(
  text,
  {
    fontFamily = "Gotham Bold, -apple-system, system-ui, BlinkMacSystemFont, Tahoma, Segoe UI, Helvetica",
    fill = "0xffffff",
    ...opt
  }
) {
  return new PIXI.Text(text, {
    fontFamily,
    fill,
    ...opt
  });
}
